var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const CloseCircle = (_a) => {
    var { color = '#454957', width = 32, height = 32, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", Object.assign({ width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fill: color, d: "M16 2.667C8.652 2.667 2.665 8.653 2.665 16s5.987 13.333 13.333 13.333c7.347 0 13.334-5.986 13.334-13.333S23.346 2.667 15.999 2.667Zm4.48 16.4a1.006 1.006 0 0 1 0 1.413c-.2.2-.454.293-.707.293a.99.99 0 0 1-.707-.293l-3.067-3.067-3.066 3.067a.99.99 0 0 1-.707.293.989.989 0 0 1-.707-.293 1.006 1.006 0 0 1 0-1.413L14.586 16l-3.067-3.067a1.006 1.006 0 0 1 0-1.413 1.006 1.006 0 0 1 1.414 0l3.066 3.067 3.067-3.067a1.006 1.006 0 0 1 1.413 0 1.006 1.006 0 0 1 0 1.413L17.413 16l3.066 3.067Z" })));
};
export default CloseCircle;
